import { defineComponent as _defineComponent } from 'vue'
import LocalAnalysisCitiesSidebar from "@/components/LocalAnalysisCitiesSidebar.vue";
import LocalAnalysisFormsChart from "@/components/LocalAnalysisFormsChart.vue";
import LocalAnalysisEventsChart from "@/components/LocalAnalysisEventsChart.vue";
import LocalAnalysisClaimsChart from "@/components/LocalAnalysisClaimsChart.vue";
import AppExpandableSection from "@/components/AppExpandableSection.vue";
import LocalScatterChart from "@/components/LocalScatterChart.vue";

import { computed } from "vue";
import { useRoute } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'LocalAnalysisView',
  setup(__props) {

const route = useRoute();

const city = computed(() => route.query.stadt?.toString());

return { __sfc: true,route, city, LocalAnalysisCitiesSidebar, LocalAnalysisFormsChart, LocalAnalysisEventsChart, LocalAnalysisClaimsChart, AppExpandableSection, LocalScatterChart }
}

})